export const locale = {
    lang: 'fr',
    data: {
        IMPORT: 'Importer cartes d\'un tableau',
        BOARD: 'Tableau',
        SELECTION: 'Sélection',
        LIST: 'Liste',
    }
};
